import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { AlbatoMondayStatusService } from '@ninety/platform/services/services/albato-monday-status.service';
import { FeatureFlagKeys } from '@ninety/platform/state/app-entities/feature-flag/feature-flag-state.model';
import { selectFeatureFlag } from '@ninety/platform/state/app-entities/feature-flag/feature-flag-state.selectors';
import { ALBATO_MONDAY_STATUS_READER, WEB_INTEGRATION_LANDING_MODE_3_STREAM } from '@ninety/ui/core';

/**
 * Binds the tokens consumed by `AlbatoMondayUpdateBannerComponent` in `@ninety/ui/core` to their
 * platform-backed implementations: `AlbatoMondayStatusService` itself, and
 * `selectFeatureFlag(FeatureFlagKeys.webIntegrationLandingMode3)` — the same flag the Integrations page
 * uses to switch to the new card list. The component stays free of `@ninety/platform/services` and
 * `@ninety/platform/state`, neither of which has a build target, so this composition-root wiring is the
 * single place that depends on both sides.
 */
export const ALBATO_MONDAY_UPDATE_BANNER_PROVIDERS: Provider[] = [
  { provide: ALBATO_MONDAY_STATUS_READER, useExisting: AlbatoMondayStatusService },
  {
    provide: WEB_INTEGRATION_LANDING_MODE_3_STREAM,
    useFactory: (store: Store) => store.select(selectFeatureFlag(FeatureFlagKeys.webIntegrationLandingMode3)),
    deps: [Store],
  },
];
